import OptionChainToolActions from "@redux/feature/Markets/Options/actions/OptionChainTool";
export default (function () {
    return {
        search: {
            optionChainToolActions: new OptionChainToolActions(),
        },
    };
});
